import * as React from 'react';

function SvgGrid3X3Gap(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M4 2v2H2V2h2zm1 12v-2a1 1 0 00-1-1H2a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1zm0-5V7a1 1 0 00-1-1H2a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1zm0-5V2a1 1 0 00-1-1H2a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1zm5 10v-2a1 1 0 00-1-1H7a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1zm0-5V7a1 1 0 00-1-1H7a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1zm0-5V2a1 1 0 00-1-1H7a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1zM9 2v2H7V2h2zm5 0v2h-2V2h2zM4 7v2H2V7h2zm5 0v2H7V7h2zm5 0h-2v2h2V7zM4 12v2H2v-2h2zm5 0v2H7v-2h2zm5 0v2h-2v-2h2zM12 1a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1V2a1 1 0 00-1-1h-2zm-1 6a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1V7zm1 4a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 00-1-1h-2z' />
		</svg>
	);
}

export default SvgGrid3X3Gap;
